/* eslint-disable react/forbid-elements */
import * as React from 'react';

export const DownloadIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
      <path
        d="M8.00005 8.36463L8.00006 0H6.00005L6.00005 8.36463L3.1776 5.76452L1.82251 7.23548L7.00005 12.0052L12.1776 7.23548L10.8225 5.76452L8.00005 8.36463Z"
        fill="white"
      />
      <path d="M2 10V14H12V10H14V14C14 15.1046 13.1046 16 12 16H2C0.89543 16 0 15.1046 0 14V10H2Z" fill="white" />
    </svg>
  );
};
